import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';





import RegistrationTypeCard from './components/RegistrationTypeCard';
import VARegistrationForm from './components/VARegistrationForm';
import PartnerRegistrationForm from './components/PartnerRegistrationForm';

const PublicRegistrationPortal = () => {
  const [registrationType, setRegistrationType] = useState(null); // 'va' or 'partner'
  const navigate = useNavigate();

  const handleBackToSelection = () => {
    setRegistrationType(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      {/* Header */}
      <header className="glass-container border-b border-white/20 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Icon name="Shield" size={32} className="text-primary" />
              <div>
                <h1 className="text-2xl font-bold text-foreground">RoamSure LLC</h1>
                <p className="text-sm text-muted-foreground">Secure Travel Management Platform</p>
              </div>
            </div>
            <Button
              variant="outline"
              iconName="ArrowLeft"
              onClick={() => navigate('/user-access-dashboard')}
            >
              Back to Dashboard
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {!registrationType ? (
          <div className="space-y-8">
            {/* Hero Section */}
            <div className="text-center space-y-4">
              <h2 className="text-4xl font-bold text-foreground">Join RoamSure Network</h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Create your account and begin the application process. Choose your registration path below.
              </p>
            </div>

            {/* Registration Type Selection */}
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              <RegistrationTypeCard
                icon="UserCheck"
                title="VA Candidate Registration"
                description="For military veterans seeking travel management positions with verified credentials and security clearance."
                features={[
                  'Military service verification',
                  'Security clearance validation',
                  'Skills assessment',
                  'Fast-track approval process'
                ]}
                buttonText="Register as VA"
                onClick={() => setRegistrationType('va')}
              />

              <RegistrationTypeCard
                icon="Building2"
                title="Travel Partner Registration"
                description="For travel service organizations seeking to join our trusted partner network with comprehensive compliance."
                features={[
                  'Company verification',
                  'Licensing validation',
                  'Compliance documentation',
                  'Service capability assessment'
                ]}
                buttonText="Register as Partner"
                onClick={() => setRegistrationType('partner')}
              />
            </div>

            {/* Benefits Section */}
            <div className="glass-container rounded-2xl p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-foreground mb-6 text-center">Why Join RoamSure?</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center space-y-2">
                  <Icon name="Shield" size={40} className="text-primary mx-auto" />
                  <h4 className="font-semibold text-foreground">Secure Platform</h4>
                  <p className="text-sm text-muted-foreground">Enterprise-grade security with GDPR compliance</p>
                </div>
                <div className="text-center space-y-2">
                  <Icon name="Zap" size={40} className="text-success mx-auto" />
                  <h4 className="font-semibold text-foreground">Fast Processing</h4>
                  <p className="text-sm text-muted-foreground">Automated validation and quick approval workflows</p>
                </div>
                <div className="text-center space-y-2">
                  <Icon name="Users" size={40} className="text-warning mx-auto" />
                  <h4 className="font-semibold text-foreground">Trusted Network</h4>
                  <p className="text-sm text-muted-foreground">Join verified professionals and organizations</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="max-w-4xl mx-auto">
            {/* Back Button */}
            <Button
              variant="ghost"
              iconName="ArrowLeft"
              onClick={handleBackToSelection}
              className="mb-6"
            >
              Back to Registration Type
            </Button>

            {/* Registration Form */}
            {registrationType === 'va' ? (
              <VARegistrationForm onSuccess={() => navigate('/user-access-dashboard')} />
            ) : (
              <PartnerRegistrationForm onSuccess={() => navigate('/partner-application-submission')} />
            )}
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="glass-container border-t border-white/20 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © 2026 RoamSure LLC. All rights reserved.
            </p>
            <div className="flex gap-6">
              <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </button>
              <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </button>
              <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicRegistrationPortal;